import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const chatMessageVariants = cva('flex flex-col rounded relative [&:not(:first-of-type)]:border-t [&:not(:first-of-type)]:border-solid [&:not(:first-of-type)]:border-bright', {
  variants: {
    variant: {
      default: '',
      reply: "bg-bright p-3 mt-3 mb-3 relative before:absolute before:top-[-12px] before:left-0 before:right-0 before:h-px before:w-full before:bg-bright before:content-['']"
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});

const ChatMessageWrapper = React.forwardRef(({ variant, className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat-message-wrapper', chatMessageVariants({ variant }), className)}
    {...props}
  />
));
ChatMessageWrapper.displayName = 'ChatMessageWrapper';

const ChatMessage = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat-message', 'flex items-start gap-2 py-3', className)}
    {...props}
  />
));
ChatMessage.displayName = 'ChatMessage';

const ChatMessageInside = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat-message-inside', 'w-[60px] grow', className)}
    {...props}
  />
));
ChatMessageInside.displayName = 'ChatMessageInside';

const ChatMessageHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat-message-header', 'flex items-center gap-2 [&_.c-badge]:shrink-0', className)}
    {...props}
  />
));
ChatMessageHeader.displayName = 'ChatMessageHeader';

const ChatMessageTitle = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat-message-header', 'mb-0 inline-block max-w-full truncate text-sm font-bold text-primary-dark', className)}
    {...props}
  />
));
ChatMessageTitle.displayName = 'ChatMessageTitle';

const ChatMessageBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat-message-body', className)}
    {...props}
  />
));
ChatMessageBody.displayName = 'ChatMessageBody';

const ChatMessageText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-chat-message-text', 'mb-0 text-sm text-neutral-dark', className)}
    {...props}
  />
));
ChatMessageText.displayName = 'ChatMessageText';

const ChatMessageActions = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat-message-actions', 'flex shrink-0 flex-col gap-2', className)}
    {...props}
  />
));
ChatMessageActions.displayName = 'ChatMessageActions';

export { ChatMessageWrapper, ChatMessage, ChatMessageInside, ChatMessageHeader, ChatMessageTitle, ChatMessageBody, ChatMessageText, ChatMessageActions };
